import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { camelizeKeys } from 'humps';
import { getOrgTermsContent } from '../../content/utils.js';
import {
  EditPortfolioLink,
  NewProjectLink,
  PortfolioInfoLink,
  PortfolioSettingsLink,
} from '../links/index.jsx';
import { EditBlueIcon } from '../icons/EditBlueIcon.jsx';
import { DeleteBlueIcon } from '../icons/DeleteBlueIcon.jsx';
import { PlusButtonBlueIcon } from '../icons/PlusButtonBlueIcon.jsx';
import CustomizeStakeholderAnalysisIcon from '../icons/CustomizeStakeholderAnalysisIcon.jsx';
import { EyeIcon } from '../icons/EyeIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';
import DownloadReportIcon from '../icons/DownloadReportIcon.jsx';

const PortfoliosActionDropdown = ({
  portfolioId,
  onDeletePortfolio,
  portfolio,
  onDownloadPDF,
  pdfLoading,
  onDownloadPNG,
  pngLoading,
}) => {
  const { canRead, canManage, canDelete } = camelizeKeys(portfolio.permissions);
  const isNoPortfolio = portfolioId === 'no_portfolio';
  const location = useLocation();
  const route = location.pathname;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (!pdfLoading && !pngLoading) setDropdownOpen(false);
  }, [pdfLoading, pngLoading]);

  if (isNoPortfolio) {
    return null;
  }
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="portfolio-action-dropdown"
        className="btn-more btn btn-default"
        open={dropdownOpen}
        onToggle={(isOpen) => setDropdownOpen(isOpen)}
        pullRight
      >
        {(route === '/projects' || route === '/projects/archived') &&
        canRead ? (
          <PortfolioInfoLink portfolioId={portfolioId}>
            <CustomMenuItem>
              <span className="flex">
                <EyeIcon />
                <span>&nbsp; View</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </PortfolioInfoLink>
        ) : null}

        {canManage ? (
          <React.Fragment>
            <EditPortfolioLink portfolioId={portfolioId}>
              <CustomMenuItem>
                <span className="flex">
                  <EditBlueIcon />
                  <span>&nbsp; Edit</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </EditPortfolioLink>
            <NewProjectLink portfolioId={portfolioId}>
              <CustomMenuItem>
                <span className="flex">
                  <PlusButtonBlueIcon />
                  <span>&nbsp; Add {getOrgTermsContent('project')}</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </NewProjectLink>
            <PortfolioSettingsLink portfolioId={portfolioId}>
              <CustomMenuItem>
                <span className="flex">
                  <CustomizeStakeholderAnalysisIcon />
                  <span>
                    &nbsp; Customize {getOrgTermsContent('portfolio')}
                  </span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </PortfolioSettingsLink>
          </React.Fragment>
        ) : null}

        {canDelete ? (
          <span className="item">
            <CustomMenuItem onClick={() => onDeletePortfolio(portfolioId)}>
              <span className="flex">
                <DeleteBlueIcon />
                <span>&nbsp; Delete</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </span>
        ) : null}

        {onDownloadPDF ? (
          <CustomMenuItem disabled={pdfLoading}>
            <button
              type="button"
              className="btn-clear bg-transparent m-0 p-0 w-100 flex"
              onClick={onDownloadPDF}
            >
              <DownloadReportIcon />
              &nbsp;
              <span className="m-l-8">
                {pdfLoading ? 'Loading...' : 'Download Chart PDF'}
              </span>
            </button>
          </CustomMenuItem>
        ) : null}
        <CustomMenuItem divider />
        {onDownloadPNG ? (
          <CustomMenuItem disabled={pngLoading}>
            <button
              type="button"
              className="btn-clear bg-transparent m-0 p-0 w-100 flex"
              onClick={onDownloadPNG}
            >
              <DownloadReportIcon />
              &nbsp;
              <span className="m-l-8">
                {pngLoading ? 'Loading...' : 'Download Chart PNG'}
              </span>
            </button>
          </CustomMenuItem>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default PortfoliosActionDropdown;
